'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../_virtual/index.cjs');
var InternalInputIcon_web = require('../../internal/InternalInputIcon/InternalInputIcon.web.cjs');
var InternalInputCaption_web = require('../../internal/InternalTextInput/InternalInputCaption/InternalInputCaption.web.cjs');
require('@emotion/react');
require('react');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
var useInputFocus = require('../../../utils/hooks/useInputFocus.cjs');
var useSanitizeInputErrors = require('../../../utils/hooks/useSanitizeInputErrors.cjs');
var SelectInput_web_styles = require('./SelectInput.web.styles.cjs');

/**
 * SelectInput component is used to provide a menu of options.
 * Includes validation for required onBlur
 *
 * {@link https://aviary.fullscript.io/latest/components/select-input-1-3/web-g4MTBmF7 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/SelectInput/SelectInput.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const SelectInput = ({ label, id, value, disabled, required, onBlur, onChange, inputCaption, errorCaption, children, customWrapperStyles, customInputStyles, ...rest })=>{
    const { isFocused, isKeyboardFocused, handleFocus, handleBlur, isDirty, selectInputRef } = useInputFocus.useInputFocus(onBlur);
    const { validationError } = index.cjsExports.useInputValidation({
        isDirty,
        required,
        value: String(value),
        label
    });
    const { hasError } = useSanitizeInputErrors.useSanitizeInputErrors(errorCaption, validationError);
    const isLabelFloating = value !== null && value !== undefined && value !== "";
    const containerStyles = [
        SelectInput_web_styles.containerStyles.base,
        disabled && SelectInput_web_styles.containerStyles.disabled,
        customWrapperStyles
    ];
    const inputStyles = [
        SelectInput_web_styles.htmlInput.base,
        isLabelFloating && SelectInput_web_styles.htmlInput.withFloatingLabel,
        hasError && !disabled && !isFocused && SelectInput_web_styles.htmlInput.error,
        customInputStyles
    ];
    const labelStyles = [
        SelectInput_web_styles.label.base,
        isLabelFloating && SelectInput_web_styles.label.floating,
        hasError && !isFocused && !disabled && value && SelectInput_web_styles.label.error
    ];
    const requiredAsterisk = ()=>{
        if (required) {
            return /*#__PURE__*/ jsxRuntime.jsx("span", {
                "aria-hidden": true,
                css: SelectInput_web_styles.requiredAsterisk,
                "data-testid": "required-asterisk",
                children: "*"
            });
        }
    };
    const renderInputInfo = ()=>{
        if (disabled && hasError || hasError && isFocused) return;
        return /*#__PURE__*/ jsxRuntime.jsx(InternalInputCaption_web.InternalInputCaption, {
            id: id,
            inputCaption: inputCaption,
            errorCaption: [
                errorCaption,
                validationError
            ]
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: containerStyles,
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: [
                    SelectInput_web_styles.floatingLabelWrapper,
                    isKeyboardFocused && SelectInput_web_styles.focusRing
                ],
                children: [
                    /*#__PURE__*/ jsxRuntime.jsxs("label", {
                        htmlFor: id,
                        css: labelStyles,
                        children: [
                            label,
                            requiredAsterisk()
                        ]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsxs("select", {
                        ref: selectInputRef,
                        id: id,
                        value: value,
                        required: required,
                        disabled: disabled,
                        css: inputStyles,
                        onChange: onChange,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "data-testid": "aviary-select-input",
                        ...rest,
                        children: [
                            /*#__PURE__*/ jsxRuntime.jsx("option", {
                                value: "",
                                hidden: true
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("div", {
                        css: SelectInput_web_styles.caretIcon,
                        children: /*#__PURE__*/ jsxRuntime.jsx(InternalInputIcon_web.InternalInputIcon, {
                            "aria-label": "View options",
                            icon: "caratDown"
                        })
                    })
                ]
            }),
            renderInputInfo()
        ]
    });
};

exports.SelectInput = SelectInput;
//# sourceMappingURL=SelectInput.web.cjs.map
